import analytics from 'universal-ga';

const googleAnalytics = (() => {
    // analytics.initialize('UA-38098944-8');
    analytics.initialize('UA-56859299-1');

    const trackEventGA = (category, action, label, value) => {
        analytics.event(category, action, label, value);
    };

    const trackVirtualPageGA = virtualPage => {
        analytics.pageview(virtualPage);
    };

    const initTracking = () => {
        analytics.pageview('/');
        console.log('GA Initialized…');
    };

    return {
        trackEventGA,
        trackVirtualPageGA,
        initTracking
    };
})();

export default googleAnalytics;



// WEBPACK FOOTER //
// ./src/scripts/core/tools/googleanalytics.js